import React from 'react';

import { loadGraphQLData } from '../page';
import MDP from './mdp-container';

export default {
    component: MDP,
    loadData: loadGraphQLData,
};
